import { render, staticRenderFns } from "./miniSettings.vue?vue&type=template&id=a4efd3de&scoped=true&"
import script from "./miniSettings.vue?vue&type=script&lang=js&"
export * from "./miniSettings.vue?vue&type=script&lang=js&"
import style0 from "./miniSettings.vue?vue&type=style&index=0&id=a4efd3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4efd3de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon})
